
<div class="tonnage-results" >
    <p-table [value]="lmtoTonnageRatings" id="LmsTonnageRatingLmtoTable" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '100rem' }" [resizableColumns]="true" [responsive]="true">
        <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let item of lmtoHeadings; " pResizableColumn>
              <div *ngFor="let item1 of item.split('|');">{{item1}} </div></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tonnage>
            <tr>
                <td>{{ tonnage.departStation }} - {{ tonnage.departMilepost }}</td>
                <td>{{ tonnage.arriveStation }} - {{ tonnage.arriveMilepost }}</td>
                <td>{{ tonnage.miles }}</td>
                <td>{{ tonnage.tonCat2 }}</td>
                <td>{{ tonnage.tonCat3 }}</td>
                <td>{{ tonnage.tonCat4 }}</td>
                <td>{{ tonnage.tonCat5 }}</td>
                <td>{{ tonnage.tonCat6 }}</td>
                <td>{{ tonnage.tonCat7 }}</td>
                <td>{{ tonnage.tonCat8 }}</td>
                <td>{{ tonnage.tonCat9 }}</td>
                <td>{{ tonnage.tonHelper }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td>No Data Found</td>
          </tr>
        </ng-template>
    </p-table>
</div>
